module.exports = __webpack_public_path__ + "h5/img/service_01.9dc48a75.jpg";